import React from 'react';

const ProjectResourceButton = ({ href, children, className = '' }) => {
    if (!href) {
        return null;
    }

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className={`inline-flex items-center justify-center rounded-lg bg-earth-900 px-5 py-3 text-sm font-semibold text-earth-50 transition-colors duration-200 hover:bg-earth-800 dark:bg-earth-50 dark:text-earth-900 dark:hover:bg-earth-200 ${className}`}
        >
            {children}
        </a>
    );
};

export default ProjectResourceButton;

